import { Line } from '@react-three/drei'
import { ThreeElements } from '@react-three/fiber'
import { useAssetVizInternal } from '@asset-viz/AssetVizInternalProvider'
import React from 'react'
import { Vector3 } from 'three'

/** Custom axesHelper that only shows 2 axes in 2D */
export const AxesHelper: React.FC<ThreeElements['group']> = (groupProps) => {
  const { show3D } = useAssetVizInternal()

  const { xAxis, yAxis, zAxis } = React.useMemo(() => {
    const origin = new Vector3(0, 0, 0)
    return {
      xAxis: {
        color: 'red',
        direction: [origin, new Vector3(1, 0, 0)],
      },
      yAxis: {
        color: 'green',
        direction: [origin, new Vector3(0, 1, 0)],
      },
      zAxis: {
        color: 'blue',
        direction: [origin, new Vector3(0, 0, 1)],
      },
    }
  }, [])

  return (
    <group {...groupProps}>
      <Line points={xAxis.direction} color={xAxis.color} />
      <Line points={yAxis.direction} color={yAxis.color} />
      <Line points={zAxis.direction} color={zAxis.color} visible={show3D} />
    </group>
  )
}
